import * as Sentry from '@sentry/react-native';

export function initSentry() {
  if (__DEV__) return;

  Sentry.init({
    dsn: process.env.EXPO_PUBLIC_SENTRY_DSN,
    sendDefaultPii: true,
    enableLogs: true,
  });
}
